import React from 'react';
import Relay from 'react-relay/classic';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import GridBase from './GridBase';
import GridHeader from './GridHeader';
import { GridItem, GridItemRelayContainer } from './GridItem';
import get from 'lodash.get';

export class GridDealer extends GridBase {
    constructor(props) {
        super(props);

        this.state = {
            quickViewItemId: null,
            loadLazyImages: false,
        };
        this.items = null;
        this._setQuickViewId = this._setQuickViewId.bind(this);
    }

    _getHeader() {
        const { dealerData, copy } = this.props;
        return <GridHeader type={dealerData.type} title={copy.dealer.carouselHeader} />;
    }

    _getItems() {
        const {
            userId,
            userIds,
            viewer,
            gridType,
            selectedItemIds,
            addFavoriting,
            loadPortfolioData,
            shouldFillInFolder,
            onFavorited,
            onAddItemSuccess,
            currency,
        } = this.props;

        const gridItemProps = {
            allowQuickView: this.props.allowQuickView,
            setQuickViewId: this._setQuickViewId,
            quickViewItemId: this.state.quickViewItemId,
            onProductClick: this.props.trackProductClick,
            addFavoriting,
            gridType,
            loadLazyImages: this.state.loadLazyImages,
            cancelLazyLoad: () => this.cancelLazyLoad(),
        };
        const pdpFolderItemRelayVariables = {
            loadPortfolioData,
            userId,
            userIds,
            selectedItemIds,
            shouldFillInFolder,
        };

        const itemsObj = {};
        if (addFavoriting && get(viewer, 'items.edges.length')) {
            viewer.items.edges.forEach(edge => {
                const item = edge.node;
                if (item && item.serviceId) {
                    itemsObj[item.serviceId] = item;
                }
            });
        }

        return this.props.data.map((data, index) => {
            // index needs to be 1-based, not 0-based
            data.index = index + 1;
            return (
                <div className="pdp-grid-item colLg3 colMd6 colXs6" key={data.id}>
                    {addFavoriting && (
                        <GridItemRelayContainer
                            itemId={data.id}
                            viewer={viewer}
                            item={itemsObj[data.id] || null}
                            allowQuickView={data.allowQuickView}
                            onFavorited={onFavorited}
                            onAddItemSuccess={onAddItemSuccess}
                            currency={currency}
                            {...gridItemProps}
                            {...data}
                            {...pdpFolderItemRelayVariables}
                        />
                    )}

                    {!addFavoriting && <GridItem itemId={data.id} {...gridItemProps} {...data} />}
                </div>
            );
        });
    }

    _getViewAll() {
        const itemPk = get(this.props, 'itemId');
        const sellerPk = get(this.props, 'dealerData.pk');

        return (
            <div className="pdp-grid-view-all-button">
                <a
                    className="button-medium button-secondary"
                    href={`/more-from-seller/?itemPk=${itemPk}&sellerPk=${sellerPk}`}
                >
                    <FormattedMessage
                        id="pdp.gridDealer.ViewAll"
                        defaultMessage="View All From Seller"
                    />
                </a>
            </div>
        );
    }
}

GridDealer.propTypes = {
    userId: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    viewer: PropTypes.object,
    data: PropTypes.array,
    dealerData: PropTypes.object.isRequired,
    copy: PropTypes.object.isRequired,
    trackProductClick: PropTypes.func,
    addFavoriting: PropTypes.bool,
    selectedItemIds: PropTypes.array,
    allowQuickView: PropTypes.bool,
    onFavorited: PropTypes.func,
    onAddItemSuccess: PropTypes.func,
    currency: PropTypes.string,
};

GridDealer.defaultProps = {
    data: [],
    domId: 'dealer-grid',
    gridType: 'more from dealer',
    addFavoriting: false,
    allowQuickView: true,
};

export const GridDealerRelayContainer = Relay.createContainer(GridDealer, {
    initialVariables: {
        first: 0,
        userId: null,
        userIds: [],
        selectedItemIds: [],
        loadPortfolioData: false,
        shouldFillInFolder: false,
    },
    prepareVariables: params => ({
        ...params,
        first: params.selectedItemIds.length,
    }),
    fragments: {
        viewer: params => Relay.QL`
                fragment on Viewer {
                    ${GridItemRelayContainer.getFragment('viewer', params)}
                    items(itemIds: $selectedItemIds, first: $first) {
                        edges {
                            node {
                                serviceId
                                ${GridItemRelayContainer.getFragment('item', params)}
                            }
                        }
                    }
                }
            `,
    },
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/Grid/GridDealer.jsx